import {Action} from '@ngrx/store';
import {BrandModel, BrandmodelModel, FollowUpStatus, BranchModel, ReferenceModel } from '../../model/index';

export const IS_AUTH = 'IS_AUTH';
export const IS_AUTH_SUCCESS = 'IS_AUTH_SUCCESS';
export const LOAD_ALL_BRAND = '[BrandModel] LOAD_ALL_BRAND';
export const LOAD_ALL_BRAND_SUCCESS = '[BrandModel] LOAD_ALL_SUCCESS_BRAND';
export const LOAD_ALL_BRAND_MODEL = '[BrandmodelModel] LOAD_ALL_BRAND_MODEL';
export const LOAD_ALL_BRAND_MODEL_SUCCESS = '[BrandmodelModel] LOAD_ALL_BRAND_MODEL_SUCCESS';
export const LOAD_ALL_FOLLOWUP_STATUS = '[FollowUpStatus] LOAD_ALL_FOLLOWUP_STATUS';
export const LOAD_ALL_FOLLOWUP_STATUS_SUCCESS = '[FollowUpStatus] LOAD_ALL_FOLLOWUP_STATUS_SUCCESS';
export const LOAD_ALL_BRANCH = '[BranchModel] LOAD_ALL_BRANCH';
export const LOAD_ALL_BRANCH_SUCCESS = '[BranchModel] LOAD_ALL_BRANCH_SUCCESS';
export const LOAD_ALL_REFERENCE = '[ReferenceModel] LOAD_ALL_REFERENCE';
export const LOAD_ALL_REFERENCE_SUCCESS = '[ReferenceModel] LOAD_ALL_REFERENCE_SUCCESS';

export class IsAuth implements Action {
	readonly type = IS_AUTH;
    constructor(public payload?: any) { }
}

export class IsAuthSuccess implements Action {
	readonly type = IS_AUTH_SUCCESS;
    constructor(public payload?: any[]) { }
}

export class LoadAllBrand implements Action {
    readonly type = LOAD_ALL_BRAND;
    constructor(public payload?: any) { }
}
export class LoadAllBrandSuccess implements Action {
    readonly type = LOAD_ALL_BRAND_SUCCESS;
    constructor(public payload?: BrandModel[]) { }
}

export class LoadAllBrandModel implements Action {
    readonly type = LOAD_ALL_BRAND_MODEL;
    constructor(public payload?: any) { }
}
export class LoadAllBrandModelSuccess implements Action {
    readonly type = LOAD_ALL_BRAND_MODEL_SUCCESS;
    constructor(public payload?: BrandmodelModel[]) { }
}

export class LoadAllFollowUpStatus implements Action {
    readonly type = LOAD_ALL_FOLLOWUP_STATUS;
    constructor(public payload?: any) { }
}
export class LoadAllFollowUpStatusSuccess implements Action {
    readonly type = LOAD_ALL_FOLLOWUP_STATUS_SUCCESS;
    constructor(public payload?: FollowUpStatus[]) { }
}

export class LoadAllBranch implements Action {
    readonly type = LOAD_ALL_BRANCH;
    constructor(public payload?: any) { }
}
export class LoadAllBranchSuccess implements Action {
    readonly type = LOAD_ALL_BRANCH_SUCCESS;
    constructor(public payload?: BranchModel[]) { }
}

export class LoadAllReference implements Action {
    readonly type = LOAD_ALL_REFERENCE;
    constructor(public payload?: any) { }
}
export class LoadAllReferenceSuccess implements Action {
    readonly type = LOAD_ALL_REFERENCE_SUCCESS;
    constructor(public payload?: ReferenceModel[]) { }
}

export type All = IsAuth | IsAuthSuccess | LoadAllBrand | LoadAllBrandSuccess | LoadAllBrandModel
    | LoadAllBrandModelSuccess | LoadAllFollowUpStatus
    | LoadAllFollowUpStatusSuccess | LoadAllBranch | LoadAllBranchSuccess | LoadAllReference | LoadAllReferenceSuccess



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/store/actions/common.actions.ts